import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { currentUser } from '../../util/currentUser';
import { app } from '../../util/firebase';

const MedicamentsEnCours = ()=> {

    const [listMedicaments, setListMedicaments ] = useState([])

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"commandesClient"),(snap)=>{
            setListMedicaments(snap.docs.map((medoc)=> medoc.data()))
        })
    },[])

    const allEnCours = ()=>{ 
        return listMedicaments.filter((commande)=> !commande.isValid && commande.user.email === currentUser.email)
        .map((commande,id)=>{
            return(
                <div className="col-md-3 mt-3 " key={id}>
                    <div className="card bg-warning text-dark">
                        {/* <img src={commande.imgSrc} className="card-img-top" alt="Laptop"/> */}
                        <div className='bg-dark' style={{backgroundImage: "url("+commande.imgSrc_commande+")",minHeight:"150px", backgroundSize:"cover", backgroundRepeat:"no-repeat"}}>
                            
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <p className="small">Pharmcie:</p>
                                <p className="small">Arafat</p>
                            </div>
    
                            <div className="d-flex justify-content-between">
                                <p >{commande.name_commande}</p>
                                <span className=" mb-0">{commande.price_commande} FCFA</span>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
}

  return (
        <div className="row">
            {allEnCours()}
        </div>
  )
}

export default MedicamentsEnCours;
